import React from "react";
import { Box, Typography, Button, useTheme, IconButton } from "@mui/material";
import {
    AccessAlarm,
    AccessTime,
    ChevronLeft as ChevronLeftIcon,
    ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import WeekSelectCalendar from "../WeekSelectCalendar";
import useResponsive from "../../hooks/useResponsive";

interface PlanningHeaderProps {
    handlePreviousWeek: () => void;
    currentWeek: string;
    handleNextWeek: () => void,
    weekStartDate: string;
    weekEndDate: string;
    onDayPress: (arg0: Date) => void;
    month: string,
    selectedDate: Date
}

const PlanningHeader: React.FC<PlanningHeaderProps> = ({
    handlePreviousWeek,
    currentWeek,
    handleNextWeek,
    weekStartDate,
    weekEndDate,
    onDayPress,
    month,
    selectedDate
}) => {
    const theme = useTheme()
    const { isMobile } = useResponsive()

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            {isMobile ?
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    height: "42px",
                    px: "5px",
                }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                                margin: 0,
                            },
                        }}
                    >
                        <IconButton size="small"
                            onClick={handlePreviousWeek}
                            sx={{
                                "&:hover": {
                                    bgcolor: theme.palette.blueColors.main, // Keep the same background color on hover
                                    backgroundColor: theme.palette.blueColors.main,
                                },
                                bgcolor: theme.palette.blueColors.main,
                                borderRadius: "8px",
                                mr: 1
                            }}
                        >
                            <ChevronLeftIcon fontSize="medium" sx={{ color: theme.palette.secondary.main }} />
                        </IconButton>
                        <Typography
                            sx={{
                                fontFamily: "Nunito Sans SemiBold",
                                fontSize: isMobile ? "14px" : "20px",
                                mr: 1
                            }}
                            color={theme.palette.blueColors.main}>Week {currentWeek}</Typography>
                        <IconButton size="small"
                            onClick={handleNextWeek}
                            sx={{
                                "&:hover": {
                                    bgcolor: theme.palette.blueColors.main, // Keep the same background color on hover
                                    backgroundColor: theme.palette.blueColors.main,
                                },
                                bgcolor: theme.palette.blueColors.main,
                                borderRadius: "8px"
                            }}
                        >
                            <ChevronRightIcon fontSize="medium" sx={{ color: theme.palette.secondary.main }} />
                        </IconButton>
                    </Box>

                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <WeekSelectCalendar
                            selectedDate={selectedDate}
                            onWeekSelect={onDayPress}
                        />

                        {/* <IconButton size="small"
                            sx={{
                                bgcolor: theme.palette.blueColors.main, borderRadius: "8px",
                                ml: 1,
                                "&:hover": {
                                    bgcolor: theme.palette.blueColors.main, // Keep the same background color on hover
                                    backgroundColor: theme.palette.blueColors.main,
                                },
                            }}
                        >
                            <AccessTime fontSize="medium" sx={{ color: theme.palette.secondary.main }} />
                        </IconButton> */}
                    </Box>
                </Box> :
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        px: "10px",
                        py: "5px",
                        // height: "54px",
                    }}
                >
                    <Typography sx={{ fontFamily: "Nunito Sans Regular700", fontSize: "22px" }}
                        color={theme.palette.blueColors.main}>
                        Taak Planning
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            // width: "155px",
                            // "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                            //     margin: 0,
                            // },
                            // bgcolor: "red"
                        }}
                    >
                        <IconButton size="small"
                            onClick={handlePreviousWeek}
                            sx={{
                                "&:hover": {
                                    bgcolor: theme.palette.blueColors.main,
                                    backgroundColor: theme.palette.blueColors.main,
                                },
                                bgcolor: theme.palette.blueColors.main,
                                borderRadius: "8px",
                                mr: 1
                            }}
                        >
                            <ChevronLeftIcon fontSize="medium" sx={{ color: theme.palette.secondary.main }} />
                        </IconButton>
                        <Typography
                            sx={{
                                fontFamily: "Nunito Sans SemiBold", fontSize: "16px",
                                flex: 1, textAlign: "center", mr: 1
                            }}
                            color={theme.palette.blueColors.main}>Week {currentWeek}</Typography>
                        <IconButton size="small"
                            onClick={handleNextWeek}
                            sx={{
                                "&:hover": {
                                    bgcolor: theme.palette.blueColors.main,
                                    backgroundColor: theme.palette.blueColors.main,
                                },
                                bgcolor: theme.palette.blueColors.main,
                                borderRadius: "8px"
                            }}
                        >
                            <ChevronRightIcon fontSize="medium" sx={{ color: theme.palette.secondary.main }} />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "Nunito Sans SemiBold",
                                fontSize: "16px",
                                flexGrow: 1,
                                textAlign: "center",
                                mr: 1
                            }}
                            color={theme.palette.blueColors.main}
                        >
                            {weekStartDate} - {weekEndDate} {month}{" "}
                        </Typography>
                        <WeekSelectCalendar
                            selectedDate={selectedDate}
                            onWeekSelect={onDayPress}
                        />
                    </Box>
                    {/* <Button variant="text">
                        <Typography
                            sx={{ alignItems: "center", fontFamily: "Nunito Sans SemiBold", fontSize: "16px" }}
                            color={theme.palette.blueColors.main}
                        >
                            Werkuren
                        </Typography>
                        <IconButton size="small"
                            sx={{
                                bgcolor: theme.palette.blueColors.main, borderRadius: "8px",
                                ml: 1,
                                "&:hover": {
                                    bgcolor: theme.palette.blueColors.main, // Keep the same background color on hover
                                    backgroundColor: theme.palette.blueColors.main,
                                },
                            }}
                        >
                            <AccessTime fontSize="medium" sx={{ color: theme.palette.secondary.main }} />
                        </IconButton>
                    </Button> */}
                </Box>
            }
            <Box
                sx={{
                    height: isMobile ? "1px" : "2px",
                    backgroundColor: theme.palette.primary.main,
                    width: "100%",
                }}
            />
        </Box>
    )

}

export default PlanningHeader;